(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7210],{

/***/ 51469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sx": function() { return /* binding */ useBreakpointValue; }
/* harmony export */ });
/* unused harmony exports Hide, Show, useBreakpoint, useColorModePreference, useMediaQuery, usePrefersReducedMotion, useQuery */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32067);
/* harmony import */ var _chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18229);
/* harmony import */ var _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54302);
// ../../../react-shim.js


// src/media-query.tsx

var getBreakpoint = (theme, value) => {
  var _a;
  return ((_a = theme == null ? void 0 : theme.breakpoints) == null ? void 0 : _a[value]) ?? value;
};
function useQuery(props) {
  const { breakpoint = "", below, above } = props;
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const bpBelow = getBreakpoint(theme, below);
  const bpAbove = getBreakpoint(theme, above);
  let query = breakpoint;
  if (bpBelow) {
    query = `(max-width: ${bpBelow})`;
  } else if (bpAbove) {
    query = `(min-width: ${bpAbove})`;
  }
  return query;
}

// src/use-media-query.ts


function useMediaQuery(query, options = {}) {
  const { ssr = true, fallback } = options;
  const env = (0,_chakra_ui_react_env__WEBPACK_IMPORTED_MODULE_2__/* .useEnvironment */ .O)();
  const queries = Array.isArray(query) ? query : [query];
  let fallbackValues = Array.isArray(fallback) ? fallback : [fallback];
  fallbackValues = fallbackValues.filter((v) => v != null);
  const [value, setValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(() => {
    return queries.map((query2, index) => ({
      media: query2,
      matches: ssr ? !!fallbackValues[index] : env.window.matchMedia(query2).matches
    }));
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    setValue(queries.map((query2) => ({
      media: query2,
      matches: env.window.matchMedia(query2).matches
    })));
    const mql = queries.map((query2) => env.window.matchMedia(query2));
    const handler = (evt) => {
      setValue((prev) => {
        return prev.slice().map((item) => {
          if (item.media === evt.media)
            return { ...item, matches: evt.matches };
          return item;
        });
      });
    };
    mql.forEach((mql2) => {
      if (typeof mql2.addListener === "function") {
        mql2.addListener(handler);
      } else {
        mql2.addEventListener("change", handler);
      }
    });
    return () => {
      mql.forEach((mql2) => {
        if (typeof mql2.removeListener === "function") {
          mql2.removeListener(handler);
        } else {
          mql2.removeEventListener("change", handler);
        }
      });
    };
  }, [env.window]);
  return value.map((item) => item.matches);
}

// src/media-query.hook.ts
function usePrefersReducedMotion(options) {
  const [prefersReducedMotion] = useMediaQuery("(prefers-reduced-motion: reduce)", options);
  return prefersReducedMotion;
}
function useColorModePreference(options) {
  const [isLight, isDark] = useMediaQuery(["(prefers-color-scheme: light)", "(prefers-color-scheme: dark)"], options);
  if (isLight)
    return "light";
  if (isDark)
    return "dark";
  return void 0;
}

// src/use-breakpoint.ts


// ../../utilities/shared-utils/src/index.ts
function isObject(value) {
  const type = typeof value;
  return value != null && (type === "object" || type === "function") && !Array.isArray(value);
}

// src/use-breakpoint.ts
function useBreakpoint(arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  const breakpoints = theme.__breakpoints.details.map(({ minMaxQuery, breakpoint }) => ({
    breakpoint,
    query: minMaxQuery.replace("@media screen and ", "")
  }));
  const fallback = breakpoints.map((bp) => bp.breakpoint === opts.fallback);
  const values = useMediaQuery(breakpoints.map((bp) => bp.query), { fallback, ssr: opts.ssr });
  const index = values.findIndex((value) => value == true);
  return ((_a = breakpoints[index]) == null ? void 0 : _a.breakpoint) ?? opts.fallback;
}

// src/use-breakpoint-value.ts



// src/media-query.utils.ts

function getClosestValue(values, breakpoint, breakpoints = _chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .breakpoints */ .AV) {
  let index = Object.keys(values).indexOf(breakpoint);
  if (index !== -1) {
    return values[breakpoint];
  }
  let stopIndex = breakpoints.indexOf(breakpoint);
  while (stopIndex >= 0) {
    const key = breakpoints[stopIndex];
    if (values.hasOwnProperty(key)) {
      index = stopIndex;
      break;
    }
    stopIndex -= 1;
  }
  if (index !== -1) {
    const key = breakpoints[index];
    return values[key];
  }
  return void 0;
}

// src/use-breakpoint-value.ts
function useBreakpointValue(values, arg) {
  var _a;
  const opts = isObject(arg) ? arg : { fallback: arg ?? "base" };
  const breakpoint = useBreakpoint(opts);
  const theme = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_1__/* .useTheme */ .Fg)();
  if (!breakpoint)
    return;
  const breakpoints = Array.from(((_a = theme.__breakpoints) == null ? void 0 : _a.keys) || []);
  const obj = Array.isArray(values) ? Object.fromEntries(Object.entries((0,_chakra_ui_breakpoint_utils__WEBPACK_IMPORTED_MODULE_3__/* .arrayToObjectNotation */ .Yq)(values, breakpoints)).map(([key, value]) => [key, value])) : values;
  return getClosestValue(obj, breakpoint, breakpoints);
}

// src/visibility.tsx
function Visibility(props) {
  const { breakpoint, hide, children, ssr } = props;
  const [show] = useMediaQuery(breakpoint, { ssr });
  const isVisible = hide ? !show : show;
  const rendered = isVisible ? children : null;
  return rendered;
}

// src/show.tsx
function Show(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    ssr
  }, children);
}
Show.displayName = "Show";

// src/hide.tsx
function Hide(props) {
  const { children, ssr } = props;
  const query = useQuery(props);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Visibility, {
    breakpoint: query,
    hide: true,
    ssr
  }, children);
}
Hide.displayName = "Hide";



/***/ }),

/***/ 82247:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.Q = function IoMdPin (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 32c-88.004 0-160 70.557-160 156.801C96 306.4 256 480 256 480s160-173.6 160-291.199C416 102.557 344.004 32 256 32zm0 212.801c-31.996 0-57.144-24.645-57.144-56 0-31.357 25.147-56 57.144-56s57.144 24.643 57.144 56c0 31.355-25.148 56-57.144 56z"}}]})(props);
};


/***/ }),

/***/ 43818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.c = function IoCheckmarkCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M256 48C141.31 48 48 141.31 48 256s93.31 208 208 208 208-93.31 208-208S370.69 48 256 48zm108.25 138.29l-134.4 160a16 16 0 01-12 5.71h-.27a16 16 0 01-11.89-5.3l-57.6-64a16 16 0 1123.78-21.4l45.29 50.32 122.59-145.91a16 16 0 0124.5 20.58z"}}]})(props);
};


/***/ }),

/***/ 63733:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.d = function IoChevronBack (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"48","d":"M328 112L184 256l144 144"}}]})(props);
};


/***/ }),

/***/ 43560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.P = function IoEllipsisHorizontal (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"circle","attr":{"cx":"256","cy":"256","r":"48"}},{"tag":"circle","attr":{"cx":"416","cy":"256","r":"48"}},{"tag":"circle","attr":{"cx":"96","cy":"256","r":"48"}}]})(props);
};


/***/ }),

/***/ 3701:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.n = function IoStar (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"d":"M394 480a16 16 0 01-9.39-3L256 383.76 127.39 477a16 16 0 01-24.55-18.08L153 310.35 23 221.2a16 16 0 019-29.2h160.38l48.4-148.95a16 16 0 0130.44 0l48.4 149H480a16 16 0 019.05 29.2L359 310.35l50.13 148.53A16 16 0 01394 480z"}}]})(props);
};


/***/ }),

/***/ 38987:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.J = function IoStarOutline (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 512 512"},"child":[{"tag":"path","attr":{"fill":"none","strokeLinejoin":"round","strokeWidth":"32","d":"M480 208H308L256 48l-52 160H32l140 96-54 160 138-100 138 100-54-160z"}}]})(props);
};


/***/ }),

/***/ 78975:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseForOwn = __webpack_require__(47816);

/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */
function baseInverter(object, setter, iteratee, accumulator) {
  baseForOwn(object, function(value, key, object) {
    setter(accumulator, iteratee(value), key, object);
  });
  return accumulator;
}

module.exports = baseInverter;


/***/ }),

/***/ 17779:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseInverter = __webpack_require__(78975);

/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */
function createInverter(setter, toIteratee) {
  return function(object, iteratee) {
    return baseInverter(object, setter, toIteratee(iteratee), {});
  };
}

module.exports = createInverter;


/***/ }),

/***/ 75703:
/***/ (function(module) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 63137:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var constant = __webpack_require__(75703),
    createInverter = __webpack_require__(17779),
    identity = __webpack_require__(6557);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */
var invert = createInverter(function(result, value, key) {
  if (value != null &&
      typeof value.toString != 'function') {
    value = nativeObjectToString.call(value);
  }

  result[value] = key;
}, constant(identity));

module.exports = invert;


/***/ }),

/***/ 50303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ ImageSlider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23887);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71911);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30719);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_5__);








// CSS


var InnerImage = function(param) {
    var image = param.image, url = param.url, hideCopyright = param.hideCopyright;
    var Image = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
        pos: "relative",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Img */ .Ei, {
                width: "100%",
                src: image.imageStyle.url,
                htmlWidth: image.imageStyle.width,
                htmlHeight: image.imageStyle.height,
                alt: image.alt || "",
                loading: "lazy"
            }),
            !hideCopyright && image.copyright && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, {
                pos: "absolute",
                left: 0,
                bottom: 0,
                bg: "rgba(0,0,0, .4)",
                color: "white",
                p: 1,
                fontSize: "xxs",
                children: image.copyright
            })
        ]
    });
    return url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: url,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            children: Image
        })
    }) : Image;
};
var ImageSlider = function(_param) {
    var images = _param.images, url = _param.url, hideCopyright = _param.hideCopyright, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "images",
        "url",
        "hideCopyright"
    ]);
    if (images.length === 1) {
        var image = images[0];
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props), {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InnerImage, {
                hideCopyright: hideCopyright,
                image: image,
                url: url
            })
        }));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props), {
        __css: {
            ".swiper-pagination-bullet": {
                border: "1px solid #fff",
                width: "12px",
                height: "12px",
                bg: "rgba(0,0,0, .4)",
                opacity: 1
            },
            ".swiper-pagination-bullet-active": {
                bg: "#fff"
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, {
            modules: [
                swiper__WEBPACK_IMPORTED_MODULE_1__/* .Pagination */ .tl
            ],
            pagination: {
                clickable: true
            },
            slidesPerView: 1,
            children: images.map(function(image, i) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlide */ .o5, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(InnerImage, {
                        hideCopyright: hideCopyright,
                        image: image,
                        url: url
                    })
                }, i);
            })
        })
    }));
};


/***/ }),

/***/ 81926:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ Rating; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41799);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_rating__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99469);
/* harmony import */ var _react_icons_all_files_io5_IoStarOutline__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(38987);
/* harmony import */ var _react_icons_all_files_io5_IoStar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3701);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52494);







var Rating = function(_param) {
    var iconProps = _param.iconProps, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "iconProps"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_rating__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        emptySymbol: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            as: _react_icons_all_files_io5_IoStarOutline__WEBPACK_IMPORTED_MODULE_5__/* .IoStarOutline */ .J
        }, iconProps)),
        fullSymbol: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .JO, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
            as: _react_icons_all_files_io5_IoStar__WEBPACK_IMPORTED_MODULE_6__/* .IoStar */ .n
        }, iconProps))
    }, props));
};


/***/ }),

/***/ 15181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SearchResult": function() { return /* reexport */ SearchResult; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var dist_index_esm = __webpack_require__(47741);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__(52494);
// EXTERNAL MODULE: ./src/components/Teaser/FarmTeaser.tsx + 1 modules
var FarmTeaser = __webpack_require__(85441);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var media_query_dist_index_esm = __webpack_require__(51469);
;// CONCATENATED MODULE: ./src/utils/pagination.ts
function getOffsetForPage(page, perPage) {
    var offset = Math.max(0, (page - 1) * perPage);
    return isNaN(offset) ? 0 : offset;
}
function getNumberOfPages(total, perPage) {
    var pages = Math.max(1, Math.ceil(total / perPage));
    return isNaN(pages) ? 1 : pages;
}

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/hooks/usePagination.ts


var getTotalPages = function(total, perPage) {
    return Math.ceil(total / perPage);
};
var getCurrentPage = function(queryParam, totalPages) {
    var currentPage = 1;
    if (queryParam && queryParam !== "") {
        var parsedParam = parseInt(queryParam, 10);
        if (parsedParam >= 1 && parsedParam <= totalPages) {
            return parsedParam;
        }
    }
    return currentPage;
};
var range = function(start, end) {
    var length = end - start + 1;
    return Array.from({
        length: length
    }, function(_, i) {
        return start + i;
    });
};
/**
 * Modified version of: https://github.com/mui/material-ui/blob/master/packages/mui-material/src/usePagination/usePagination.js
 *
 * @param currentPage
 * @param maxPages
 * @param total
 * @param renderEndPages
 * @param renderStartPages
 */ var getPageList = function(currentPage) {
    var maxPages = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 9, total = arguments.length > 2 ? arguments[2] : void 0, renderEndPages = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, renderStartPages = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true;
    var boundaryCount = 1;
    var siblingCount = Math.floor(maxPages / 2);
    var startPages = range(1, Math.min(boundaryCount, total));
    var endPages = range(Math.max(total - boundaryCount + 1, boundaryCount + 1), total);
    var siblingsStart = Math.max(Math.min(// Natural start
    currentPage - siblingCount, // Lower boundary when page is high
    total - boundaryCount - siblingCount * 2 - 1), // Greater than startPages
    boundaryCount + 2);
    var siblingsEnd = Math.min(Math.max(// Natural end
    currentPage + siblingCount, // Upper boundary when page is low
    boundaryCount + siblingCount * 2 + 2), // Less than endPages
    endPages.length > 0 ? endPages[0] - 2 : total - 1);
    // Basic list of items to render
    // e.g. itemList = ['previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next']
    return [
        "previous", 
    ].concat((0,_to_consumable_array/* default */.Z)(renderStartPages ? startPages : []), // Start ellipsis
    (0,_to_consumable_array/* default */.Z)(siblingsStart > boundaryCount + 2 ? [
        "ellipsis"
    ] : boundaryCount + 1 < total - boundaryCount ? [
        boundaryCount + 1
    ] : []), // Sibling pages
    (0,_to_consumable_array/* default */.Z)(range(siblingsStart, siblingsEnd)), // End ellipsis
    (0,_to_consumable_array/* default */.Z)(siblingsEnd < total - boundaryCount - 1 ? [
        "ellipsis"
    ] : total - boundaryCount > boundaryCount ? [
        total - boundaryCount
    ] : []), (0,_to_consumable_array/* default */.Z)(renderEndPages ? endPages : []), [
        "next", 
    ]);
};
function usePagination(param) {
    var _param = param.param, _$param = _param === void 0 ? "page" : _param, perPage = param.perPage, total = param.total, maxPages = param.maxPages, renderStartPages = param.renderStartPages, renderEndPages = param.renderEndPages;
    var router = (0,next_router.useRouter)();
    var totalPages = getTotalPages(total, perPage);
    var currentPage = getCurrentPage(router.query[_$param], totalPages);
    var pageList = getPageList(currentPage, maxPages, totalPages, renderEndPages, renderStartPages);
    return {
        currentPage: currentPage,
        pageList: pageList,
        totalPages: totalPages
    };
};

// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io5/IoEllipsisHorizontal.js
var IoEllipsisHorizontal = __webpack_require__(43560);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io5/IoChevronForward.js
var IoChevronForward = __webpack_require__(18935);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io5/IoChevronBack.js
var IoChevronBack = __webpack_require__(63733);
;// CONCATENATED MODULE: ./src/components/Common/Pagination.tsx













var Pagination = function(_param) {
    var _$_param = _param.param, param = _$_param === void 0 ? "page" : _$_param, total = _param.total, perPage = _param.perPage, props = (0,_object_without_properties/* default */.Z)(_param, [
        "param",
        "total",
        "perPage"
    ]);
    var numberOfPages = getNumberOfPages(total, perPage);
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)({
        maxPages: 9,
        renderEndPages: true,
        renderStartPages: true
    }), paginationSettings = ref[0], setPaginationSettings = ref[1];
    var maxPagesBreakpointValues = (0,media_query_dist_index_esm/* useBreakpointValue */.Sx)({
        base: 3,
        md: 6,
        lg: 9
    });
    var renderStartAndEndPages = (0,media_query_dist_index_esm/* useBreakpointValue */.Sx)({
        base: false,
        md: true,
        lg: true
    });
    var ref1 = usePagination((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, paginationSettings), {
        perPage: perPage,
        total: total,
        param: param
    })), currentPage = ref1.currentPage, pageList = ref1.pageList, totalPages = ref1.totalPages;
    (0,react.useEffect)(function() {
        setPaginationSettings({
            maxPages: maxPagesBreakpointValues,
            renderStartPages: renderStartAndEndPages,
            renderEndPages: renderStartAndEndPages
        });
    }, [
        maxPagesBreakpointValues,
        renderStartAndEndPages
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Stack */.Kq, {
        marginY: 8,
        justifyContent: "center",
        direction: "row",
        wrap: "wrap",
        color: "primary",
        children: pageList.map(function(page, i) {
            if (page === "ellipsis") {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                    alignItems: "flex-end",
                    pb: 1.5,
                    px: 2,
                    fontSize: "sm",
                    display: {
                        base: "none",
                        md: "flex"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                        as: IoEllipsisHorizontal/* IoEllipsisHorizontal */.P
                    })
                }, i);
            }
            if (page === "previous" && currentPage === 1) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                    variant: "outline",
                    borderRadius: "sm",
                    isDisabled: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                        as: IoChevronBack/* IoChevronBack */.d
                    })
                }, "prev-disabled");
            }
            if (page === "next" && currentPage === totalPages) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                    variant: "outline",
                    borderRadius: "sm",
                    isDisabled: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                        as: IoChevronForward/* IoChevronForward */.m
                    })
                }, "next-disabled");
            }
            var isActive = page === currentPage;
            var pageUrlParam = page === "previous" ? "".concat(Math.max(1, currentPage - 1)) : page === "next" ? "".concat(Math.min(totalPages, currentPage + 1)) : "".concat(page);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: {
                    pathname: router.pathname,
                    query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                        page: pageUrlParam
                    })
                },
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Button */.zx, {
                    as: "a",
                    variant: "outline",
                    borderRadius: "sm",
                    isActive: isActive,
                    _active: {
                        bg: "primary",
                        color: "#fff"
                    },
                    _hover: {
                        bg: "gray.200"
                    },
                    children: typeof page === "number" ? page : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                        as: page === "previous" ? IoChevronBack/* IoChevronBack */.d : IoChevronForward/* IoChevronForward */.m
                    })
                })
            }, "".concat(page, "-").concat(i));
        })
    });
};
/* harmony default export */ var Common_Pagination = (Pagination);

// EXTERNAL MODULE: ./src/context/SearchContext.ts
var SearchContext = __webpack_require__(9829);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io5/IoClose.js
var IoClose = __webpack_require__(5981);
// EXTERNAL MODULE: ./src/utils/getFilterGroups.ts
var getFilterGroups = __webpack_require__(90408);
// EXTERNAL MODULE: ./src/utils/filters.ts
var filters = __webpack_require__(97126);
// EXTERNAL MODULE: ./src/utils/urls.ts
var urls = __webpack_require__(996);
;// CONCATENATED MODULE: ./src/components/Paragraph/SearchResult/SearchResult.tsx












var SearchResult = function(param) {
    var data = param.data;
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var sortedData = (0,react.useMemo)(function() {
        var ref, ref1;
        var groups = {
            address: [],
            premium: []
        };
        var sorted = [];
        (ref = data.result) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1.map(function(farm) {
            if (farm.listingType.title === "Address") {
                groups.address.push(farm);
            } else {
                groups.premium.push(farm);
            }
        });
        // First Address
        if (groups.address.length >= 1) {
            sorted.push(groups.address.shift());
        }
        // Then 2 Premium
        for(var i = 0; i < 2; i++){
            sorted.push(groups.premium.shift());
        }
        // Then again address
        if (groups.address.length >= 1) {
            sorted.push(groups.address.shift());
        }
        // Fill with premium and address
        // if we still have address entries (then we didnt have enough premium), just add them
        sorted = (0,_to_consumable_array/* default */.Z)(sorted).concat((0,_to_consumable_array/* default */.Z)(groups.premium), (0,_to_consumable_array/* default */.Z)(groups.address));
        return sorted.filter(Boolean);
    }, [
        data
    ]);
    var searchContext = (0,react.useContext)(SearchContext/* SearchContext */.c);
    var onRemoveFilter = function(filter) {
        var ref;
        var remainingFilters = (ref = searchContext.activeFilter) === null || ref === void 0 ? void 0 : ref.filter(function(activeFilter) {
            return activeFilter.id !== filter.id;
        });
        if (remainingFilters) {
            var filterGroups = (0,getFilterGroups/* default */.Z)(searchContext.searchMoreFilter, remainingFilters.map(function(filter) {
                return filter.id;
            }));
            var filterQuery = (0,filters/* filtersToQuery */.KV)(filterGroups);
            var newPath = (0,urls/* addParamsToPath */.b)(router.asPath, {
                filters: filterQuery,
                page: null
            });
            router.push(newPath);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        className: data.__typename,
        mt: 12,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
            maxW: "container.main",
            py: 3,
            children: [
                searchContext.activeFilter && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Wrap */.Eq, {
                    mb: 6,
                    children: searchContext.activeFilter.map(function(filter, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* WrapItem */.Uc, {
                            size: "sm",
                            alignItems: "center",
                            as: dist_index_esm/* Button */.zx,
                            borderRadius: "full",
                            border: "1px solid",
                            borderColor: "primary",
                            bg: "primaryLight50",
                            color: "primary",
                            px: 3,
                            py: 1,
                            onClick: function() {
                                onRemoveFilter(filter);
                            },
                            children: [
                                filter.title,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_dist_index_esm/* Icon */.JO, {
                                    ml: 1,
                                    as: IoClose/* IoClose */.b
                                })
                            ]
                        }, filter.id);
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                    fontSize: "lg",
                    fontWeight: "bold",
                    color: "primary",
                    children: [
                        (ref = data.result) === null || ref === void 0 ? void 0 : ref.total,
                        " Ergebnisse gefunden"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* VStack */.gC, {
                    mt: 12,
                    alignItems: "flex-start",
                    spacing: 9,
                    divider: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* StackDivider */.cX, {
                        borderColor: "gray.300"
                    }),
                    children: sortedData.map(function(farm) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmTeaser/* FarmTeaser */.S, {
                            data: farm
                        }, farm.id);
                    })
                }),
                ((ref1 = data.result) === null || ref1 === void 0 ? void 0 : ref1.total) && ((ref2 = data.result) === null || ref2 === void 0 ? void 0 : ref2.total) > sortedData.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Divider */.iz, {
                            borderColor: "gray.300",
                            opacity: 1,
                            my: 12
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Common_Pagination, {
                            total: data.result.total,
                            perPage: 6
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Paragraph/SearchResult/index.ts



/***/ }),

/***/ 85441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ FarmTeaser; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var dist_index_esm = __webpack_require__(52494);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/Common/ImageSlider.tsx
var ImageSlider = __webpack_require__(50303);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io/IoMdPin.js
var IoMdPin = __webpack_require__(82247);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io5/IoChevronForward.js
var IoChevronForward = __webpack_require__(18935);
// EXTERNAL MODULE: ./src/components/Common/Rating.tsx
var Rating = __webpack_require__(81926);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io5/IoCheckmarkCircle.js
var IoCheckmarkCircle = __webpack_require__(43818);
;// CONCATENATED MODULE: ./src/components/Node/Farm/FarmCategoryList.tsx




var FarmCategoryList = function(param) {
    var categories = param.categories;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Stack */.Kq, {
        direction: "row",
        alignItems: "center",
        flexWrap: "wrap",
        divider: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* StackDivider */.cX, {
            borderColor: "gray.300"
        }),
        spacing: 2,
        fontSize: {
            base: "sm",
            md: "md"
        },
        children: categories.map(function(categoryParagraph, i) {
            var allCategories = [
                categoryParagraph.category, 
            ].concat((0,_to_consumable_array/* default */.Z)(categoryParagraph.subCategories)).filter(function(category) {
                return category.showInTeaser;
            });
            return allCategories.map(function(cat, j) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                            mr: 1,
                            fontSize: "md",
                            as: IoCheckmarkCircle/* IoCheckmarkCircle */.c,
                            color: "primary"
                        }),
                        cat.title
                    ]
                }, j);
            });
        })
    });
};

;// CONCATENATED MODULE: ./src/components/Teaser/FarmTeaser.tsx









var FarmTeaser = function(param) {
    var data = param.data;
    var images = (0,react.useMemo)(function() {
        var ref;
        var images = [];
        if (data.teaserImage) {
            images.push(data.teaserImage);
        }
        (ref = data.images) === null || ref === void 0 ? void 0 : ref.forEach(function(image) {
            return images.push(image);
        });
        return images;
    }, [
        data
    ]);
    var isPremium = data.listingType.title === "Premium";
    var isAddress = data.listingType.title === "Address";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Grid */.rj, {
            templateColumns: "repeat(12, 1fr)",
            templateRows: {
                base: "repeat(1, 1fr)",
                md: "auto 1fr"
            },
            columnGap: {
                base: isPremium ? 0 : 3,
                md: 6
            },
            rowGap: {
                base: 0,
                md: 0
            },
            width: "100%",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* GridItem */.P4, {
                    rowSpan: 2,
                    colSpan: {
                        base: isPremium ? 12 : 4,
                        md: 4
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                        pos: "relative",
                        overflow: "hidden",
                        children: [
                            isPremium && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                textTransform: "uppercase",
                                pos: "absolute",
                                px: 8,
                                left: "-38px",
                                top: "38px",
                                zIndex: 2,
                                bg: "secondary",
                                color: "#fff",
                                fontSize: "sm",
                                fontWeight: "bold",
                                transform: "rotate(-35deg)",
                                children: "Trabland Premium"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                                justifyContent: {
                                    base: "center",
                                    md: "flex-end"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageSlider/* ImageSlider */.x, {
                                    maxW: {
                                        base: "100%",
                                        md: !isPremium ? "60%" : "100%"
                                    },
                                    images: images,
                                    url: data.url,
                                    hideCopyright: true
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* GridItem */.P4, {
                    colSpan: {
                        base: isPremium ? 12 : 8,
                        md: 8
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: data.url,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                                display: "block",
                                as: "a",
                                fontSize: {
                                    base: "lg",
                                    md: "xl"
                                },
                                fontWeight: "bold",
                                mt: {
                                    base: isPremium ? 2 : 0,
                                    md: 0
                                },
                                color: "primary",
                                _hover: {
                                    color: "primaryDark"
                                },
                                children: data.title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                fontSize: "sm",
                                alignItems: "center",
                                mt: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                                        fontSize: "lg",
                                        mr: 1,
                                        as: IoMdPin/* IoMdPin */.Q,
                                        color: "primary"
                                    }),
                                    data.address.postcode,
                                    " ",
                                    data.address.city
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* GridItem */.P4, {
                    colSpan: {
                        base: 12,
                        md: 8
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            mt: 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FarmCategoryList, {
                                categories: data.categories
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            mt: 2,
                            color: "gray.600",
                            fontSize: "sm",
                            children: data.teaserText
                        }),
                        data.voteCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Flex */.kC, {
                            alignItems: "center",
                            mt: 4,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Flex */.kC, {
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* Rating */.i, {
                                        initialRating: data.voteAverage,
                                        readonly: true,
                                        iconProps: {
                                            fontSize: "xl"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                        ml: 2,
                                        mt: "-6px",
                                        fontSize: "sm",
                                        children: [
                                            "(",
                                            data.voteCount,
                                            " Bewertungen)"
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: data.url,
                            passHref: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Box */.xu, {
                                width: {
                                    base: "100%",
                                    md: "auto"
                                },
                                justifyContent: {
                                    base: "center",
                                    md: "flex-start"
                                },
                                mt: 4,
                                as: "a",
                                layerStyle: "link_button_blue",
                                fontSize: {
                                    base: "sm",
                                    md: "md"
                                },
                                children: [
                                    "Mehr erfahren",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Icon */.JO, {
                                        ml: 1,
                                        as: IoChevronForward/* IoChevronForward */.m
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 9829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ SearchContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var SearchContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});


/***/ }),

/***/ 97126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KV": function() { return /* binding */ filtersToQuery; },
/* harmony export */   "TX": function() { return /* binding */ queryToFilters; }
/* harmony export */ });
/* unused harmony exports fieldNameToQuery, queryToFieldName, operatorToQuery, queryToOperator */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var lodash_invert__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63137);
/* harmony import */ var lodash_invert__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_invert__WEBPACK_IMPORTED_MODULE_0__);


var OPERATOR_QUERY_MAP = {
    "=": "EQ"
};
var OPERATOR_QUERY_MAP_INVERTED = lodash_invert__WEBPACK_IMPORTED_MODULE_0___default()(OPERATOR_QUERY_MAP);
var FIELD_QUERY_MAP = {
    category: "c",
    sub_categories: "sc"
};
var FIELD_QUERY_MAP_INVERTED = lodash_invert__WEBPACK_IMPORTED_MODULE_0___default()(FIELD_QUERY_MAP);
var fieldNameToQuery = function(fieldName) {
    return FIELD_QUERY_MAP[fieldName] || fieldName;
};
var queryToFieldName = function(queryFieldName) {
    return FIELD_QUERY_MAP_INVERTED[queryFieldName] || queryFieldName;
};
var operatorToQuery = function(operator) {
    return OPERATOR_QUERY_MAP[operator] || operator;
};
var queryToOperator = function(queryOperator) {
    return OPERATOR_QUERY_MAP_INVERTED[queryOperator] || queryOperator;
};
var filtersToQuery = function(filters) {
    var parts = [];
    filters.forEach(function(filterGroup) {
        var ref;
        (ref = filterGroup.conditions) === null || ref === void 0 ? void 0 : ref.forEach(function(condition) {
            parts.push("".concat(fieldNameToQuery(condition.field), ":").concat(operatorToQuery(condition.operator), ":").concat(condition.value));
        });
    });
    return parts.join("|");
};
var queryToFilters = function(query) {
    if (!query || query === "") return [];
    var filterGroups = [];
    var parts = query.split("|");
    parts.forEach(function(part) {
        var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(part.split(":"), 3), fieldName = ref[0], operator = ref[1], value = ref[2];
        filterGroups.push({
            conditions: [
                {
                    field: queryToFieldName(fieldName),
                    operator: queryToOperator(operator),
                    value: value
                }, 
            ]
        });
    });
    return filterGroups;
};


/***/ }),

/***/ 90408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getFilterGroups; }
/* harmony export */ });
function getFilterGroups(searchMoreFilter, filterIds) {
    var filterGroups = [];
    // Build groups
    searchMoreFilter.forEach(function(searchMoreFilterParagraph) {
        // Check if we have any of its categoryTerms active
        var activeItems = [];
        // Can only contain either parent or subcategories
        if (filterIds.includes(searchMoreFilterParagraph.category.id)) {
            filterGroups.push({
                conditions: [
                    {
                        field: "category",
                        value: "".concat(searchMoreFilterParagraph.category.id),
                        operator: "="
                    }, 
                ]
            });
        } else {
            var ref;
            (ref = searchMoreFilterParagraph.subCategories) === null || ref === void 0 ? void 0 : ref.forEach(function(subCategory) {
                if (filterIds.includes(subCategory.id)) {
                    activeItems.push(subCategory.id);
                }
            });
            if (activeItems.length) {
                if (searchMoreFilterParagraph.category.conjunction === "or") {
                    // Any of the following terms
                    filterGroups.push({
                        conditions: [
                            {
                                field: "sub_categories",
                                value: "".concat(activeItems.join(",")),
                                operator: "IN"
                            }, 
                        ]
                    });
                } else {
                    // each of the following terms
                    filterGroups.push({
                        conditions: activeItems.map(function(id) {
                            return {
                                field: "sub_categories",
                                value: "".concat(id),
                                operator: "="
                            };
                        })
                    });
                }
            }
        }
    });
    return filterGroups;
};


/***/ }),

/***/ 996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ addParamsToPath; }
/* harmony export */ });
/* unused harmony export removeParamsFromPath */
var PLACEHOLDER_URL = "https://www.placeholder.de";
var addParamsToPath = function(path, params) {
    var url = new URL("".concat(PLACEHOLDER_URL).concat(path));
    if (url) {
        for(var param in params){
            if (params[param] && params[param] !== "" && params[param] !== null) {
                url.searchParams.set(param, params[param]);
            } else {
                url.searchParams.delete(param);
            }
        }
        return url.toString().replace(PLACEHOLDER_URL, "");
    }
    return path;
};
var removeParamsFromPath = function(path, params, all) {
    var url = new URL("".concat(PLACEHOLDER_URL).concat(path));
    if (url) {
        url.searchParams.forEach(function(param) {
            if (all || params[param]) {
                url.searchParams.delete(param);
            }
        });
        return url.pathname;
    }
    return path;
};


/***/ }),

/***/ 99469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var style = {
  display: 'inline-block',
  borderRadius: '50%',
  border: '5px double white',
  width: 30,
  height: 30
};
var Style = {
  empty: _objectSpread({}, style, {
    backgroundColor: '#ccc'
  }),
  full: _objectSpread({}, style, {
    backgroundColor: 'black'
  }),
  placeholder: _objectSpread({}, style, {
    backgroundColor: 'red'
  })
};

// Return the corresponding React node for an icon.
var _iconNode = function _iconNode(icon) {
  // If it is already a React Element just return it.
  if (react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(icon)) {
    return icon;
  } // If it is an object, try to use it as a CSS style object.


  if (_typeof(icon) === 'object' && icon !== null) {
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
      style: icon
    });
  } // If it is a string, use it as class names.


  if (Object.prototype.toString.call(icon) === '[object String]') {
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
      className: icon
    });
  }
};

var RatingSymbol =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(RatingSymbol, _React$PureComponent);

  function RatingSymbol() {
    _classCallCheck(this, RatingSymbol);

    return _possibleConstructorReturn(this, _getPrototypeOf(RatingSymbol).apply(this, arguments));
  }

  _createClass(RatingSymbol, [{
    key: "render",
    value: function render() {
      var _iconContainerStyle;

      var _this$props = this.props,
          index = _this$props.index,
          inactiveIcon = _this$props.inactiveIcon,
          activeIcon = _this$props.activeIcon,
          percent = _this$props.percent,
          direction = _this$props.direction,
          readonly = _this$props.readonly,
          onClick = _this$props.onClick,
          onMouseMove = _this$props.onMouseMove;

      var backgroundNode = _iconNode(inactiveIcon);

      var showbgIcon = percent < 100;
      var bgIconContainerStyle = showbgIcon ? {} : {
        visibility: 'hidden'
      };

      var iconNode = _iconNode(activeIcon);

      var iconContainerStyle = (_iconContainerStyle = {
        display: 'inline-block',
        position: 'absolute',
        overflow: 'hidden',
        top: 0
      }, _defineProperty(_iconContainerStyle, direction === 'rtl' ? 'right' : 'left', 0), _defineProperty(_iconContainerStyle, "width", "".concat(percent, "%")), _iconContainerStyle);
      var style = {
        cursor: !readonly ? 'pointer' : 'inherit',
        display: 'inline-block',
        position: 'relative'
      };

      function handleMouseMove(e) {
        if (onMouseMove) {
          onMouseMove(index, e);
        }
      }

      function handleMouseClick(e) {
        if (onClick) {
          // [Supporting both TouchEvent and MouseEvent](https://developer.mozilla.org/en-US/docs/Web/API/Touch_events/Supporting_both_TouchEvent_and_MouseEvent)
          // We must prevent firing click event twice on touch devices.
          e.preventDefault();
          onClick(index, e);
        }
      }

      return react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
        style: style,
        onClick: handleMouseClick,
        onMouseMove: handleMouseMove,
        onTouchMove: handleMouseMove,
        onTouchEnd: handleMouseClick
      }, react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
        style: bgIconContainerStyle
      }, backgroundNode), react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
        style: iconContainerStyle
      }, iconNode));
    }
  }]);

  return RatingSymbol;
}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent); // Define propTypes only in development. They will be void in production.

var Rating =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Rating, _React$PureComponent);

  function Rating(props) {
    var _this;

    _classCallCheck(this, Rating);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Rating).call(this, props));
    _this.state = {
      // Indicates the value that is displayed to the user in the form of symbols.
      // It can be either 0 (for no displayed symbols) or (0, end]
      displayValue: _this.props.value,
      // Indicates if the user is currently hovering over the rating element
      interacting: false
    };
    _this.onMouseLeave = _this.onMouseLeave.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.symbolMouseMove = _this.symbolMouseMove.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.symbolClick = _this.symbolClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(Rating, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var valueChanged = this.props.value !== nextProps.value;
      this.setState(function (prevState) {
        return {
          displayValue: valueChanged ? nextProps.value : prevState.displayValue
        };
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      // Ignore state update due to value changed from props.
      // Usually originated through an onClick event.
      if (prevProps.value !== this.props.value) {
        return;
      } // When hover ends, call this.props.onHover with no value.


      if (prevState.interacting && !this.state.interacting) {
        return this.props.onHover();
      } // When hover over.


      if (this.state.interacting) {
        this.props.onHover(this.state.displayValue);
      }
    }
  }, {
    key: "symbolClick",
    value: function symbolClick(symbolIndex, event) {
      var value = this.calculateDisplayValue(symbolIndex, event);
      this.props.onClick(value, event);
    }
  }, {
    key: "symbolMouseMove",
    value: function symbolMouseMove(symbolIndex, event) {
      var value = this.calculateDisplayValue(symbolIndex, event); // This call should cause an update only if the state changes.
      // Mainly the first time the mouse enters and whenever the value changes.
      // So DidComponentUpdate is NOT called for every mouse movement.

      this.setState({
        interacting: !this.props.readonly,
        displayValue: value
      });
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave() {
      this.setState({
        displayValue: this.props.value,
        interacting: false
      });
    }
  }, {
    key: "calculateDisplayValue",
    value: function calculateDisplayValue(symbolIndex, event) {
      var percentage = this.calculateHoverPercentage(event); // Get the closest top fraction.

      var fraction = Math.ceil(percentage % 1 * this.props.fractions) / this.props.fractions; // Truncate decimal trying to avoid float precission issues.

      var precision = Math.pow(10, 3);
      var displayValue = symbolIndex + (Math.floor(percentage) + Math.floor(fraction * precision) / precision); // ensure the returned value is greater than 0 and lower than totalSymbols

      return displayValue > 0 ? displayValue > this.props.totalSymbols ? this.props.totalSymbols : displayValue : 1 / this.props.fractions;
    }
  }, {
    key: "calculateHoverPercentage",
    value: function calculateHoverPercentage(event) {
      var clientX = event.nativeEvent.type.indexOf("touch") > -1 ? event.nativeEvent.type.indexOf("touchend") > -1 ? event.changedTouches[0].clientX : event.touches[0].clientX : event.clientX;
      var targetRect = event.target.getBoundingClientRect();
      var delta = this.props.direction === 'rtl' ? targetRect.right - clientX : clientX - targetRect.left; // Returning 0 if the delta is negative solves the flickering issue

      return delta < 0 ? 0 : delta / targetRect.width;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          readonly = _this$props.readonly,
          quiet = _this$props.quiet,
          totalSymbols = _this$props.totalSymbols,
          value = _this$props.value,
          placeholderValue = _this$props.placeholderValue,
          direction = _this$props.direction,
          emptySymbol = _this$props.emptySymbol,
          fullSymbol = _this$props.fullSymbol,
          placeholderSymbol = _this$props.placeholderSymbol,
          className = _this$props.className,
          id = _this$props.id,
          style = _this$props.style,
          tabIndex = _this$props.tabIndex;
      var _this$state = this.state,
          displayValue = _this$state.displayValue,
          interacting = _this$state.interacting;
      var symbolNodes = [];
      var empty = [].concat(emptySymbol);
      var full = [].concat(fullSymbol);
      var placeholder = [].concat(placeholderSymbol);
      var shouldDisplayPlaceholder = placeholderValue !== 0 && value === 0 && !interacting; // The value that will be used as base for calculating how to render the symbols

      var renderedValue;

      if (shouldDisplayPlaceholder) {
        renderedValue = placeholderValue;
      } else {
        renderedValue = quiet ? value : displayValue;
      } // The amount of full symbols


      var fullSymbols = Math.floor(renderedValue);

      for (var i = 0; i < totalSymbols; i++) {
        var percent = void 0; // Calculate each symbol's fullness percentage

        if (i - fullSymbols < 0) {
          percent = 100;
        } else if (i - fullSymbols === 0) {
          percent = (renderedValue - i) * 100;
        } else {
          percent = 0;
        }

        symbolNodes.push(react__WEBPACK_IMPORTED_MODULE_0__.createElement(RatingSymbol, _extends({
          key: i,
          index: i,
          readonly: readonly,
          inactiveIcon: empty[i % empty.length],
          activeIcon: shouldDisplayPlaceholder ? placeholder[i % full.length] : full[i % full.length],
          percent: percent,
          direction: direction
        }, !readonly && {
          onClick: this.symbolClick,
          onMouseMove: this.symbolMouseMove,
          onTouchMove: this.symbolMouseMove,
          onTouchEnd: this.symbolClick
        })));
      }

      return react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", _extends({
        id: id,
        style: _objectSpread({}, style, {
          display: 'inline-block',
          direction: direction
        }),
        className: className,
        tabIndex: tabIndex,
        "aria-label": this.props['aria-label']
      }, !readonly && {
        onMouseLeave: this.onMouseLeave
      }), symbolNodes);
    }
  }]);

  return Rating;
}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent); // Define propTypes only in development.

function noop() {}

noop._name = 'react_rating_noop';

var RatingAPILayer =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(RatingAPILayer, _React$PureComponent);

  function RatingAPILayer(props) {
    var _this;

    _classCallCheck(this, RatingAPILayer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RatingAPILayer).call(this, props));
    _this.state = {
      value: props.initialRating
    };
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    _this.handleHover = _this.handleHover.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(RatingAPILayer, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState({
        value: nextProps.initialRating
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick(value, e) {
      var _this2 = this;

      var newValue = this.translateDisplayValueToValue(value);
      this.props.onClick(newValue); // Avoid calling setState if not necessary. Micro optimisation.

      if (this.state.value !== newValue) {
        // If we have a new value trigger onChange callback.
        this.setState({
          value: newValue
        }, function () {
          return _this2.props.onChange(_this2.state.value);
        });
      }
    }
  }, {
    key: "handleHover",
    value: function handleHover(displayValue) {
      var value = displayValue === undefined ? displayValue : this.translateDisplayValueToValue(displayValue);
      this.props.onHover(value);
    }
  }, {
    key: "translateDisplayValueToValue",
    value: function translateDisplayValueToValue(displayValue) {
      var translatedValue = displayValue * this.props.step + this.props.start; // minimum value cannot be equal to start, since it's exclusive

      return translatedValue === this.props.start ? translatedValue + 1 / this.props.fractions : translatedValue;
    }
  }, {
    key: "tranlateValueToDisplayValue",
    value: function tranlateValueToDisplayValue(value) {
      if (value === undefined) {
        return 0;
      }

      return (value - this.props.start) / this.props.step;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          step = _this$props.step,
          emptySymbol = _this$props.emptySymbol,
          fullSymbol = _this$props.fullSymbol,
          placeholderSymbol = _this$props.placeholderSymbol,
          readonly = _this$props.readonly,
          quiet = _this$props.quiet,
          fractions = _this$props.fractions,
          direction = _this$props.direction,
          start = _this$props.start,
          stop = _this$props.stop,
          id = _this$props.id,
          className = _this$props.className,
          style = _this$props.style,
          tabIndex = _this$props.tabIndex;

      function calculateTotalSymbols(start, stop, step) {
        return Math.floor((stop - start) / step);
      }

      return react__WEBPACK_IMPORTED_MODULE_0__.createElement(Rating, {
        id: id,
        style: style,
        className: className,
        tabIndex: tabIndex,
        "aria-label": this.props['aria-label'],
        totalSymbols: calculateTotalSymbols(start, stop, step),
        value: this.tranlateValueToDisplayValue(this.state.value),
        placeholderValue: this.tranlateValueToDisplayValue(this.props.placeholderRating),
        readonly: readonly,
        quiet: quiet,
        fractions: fractions,
        direction: direction,
        emptySymbol: emptySymbol,
        fullSymbol: fullSymbol,
        placeholderSymbol: placeholderSymbol,
        onClick: this.handleClick,
        onHover: this.handleHover
      });
    }
  }]);

  return RatingAPILayer;
}(react__WEBPACK_IMPORTED_MODULE_0__.PureComponent);

RatingAPILayer.defaultProps = {
  start: 0,
  stop: 5,
  step: 1,
  readonly: false,
  quiet: false,
  fractions: 1,
  direction: 'ltr',
  onHover: noop,
  onClick: noop,
  onChange: noop,
  emptySymbol: Style.empty,
  fullSymbol: Style.full,
  placeholderSymbol: Style.placeholder
}; // Define propTypes only in development.

/* harmony default export */ __webpack_exports__["Z"] = (RatingAPILayer);


/***/ })

}]);